<template>
  <base-dropdown
    ref="selection"
    v-model="selectedValue"
    :name="name"
    :options="items"
    :option-label="optionLabel"
    :option-value="optionValue"
    :placeholder="placeholder"
    :model-value="modelValue"
    :icon="false"
    :input-attrs="inputAttrs"
    :loading="loading"
    :addon="addon"
    :btn-create="btnCreate"
    :disabled="disabled"
    :noMarginTop="noMarginTop"
    @change="change"
    @btn-create="addNewItem"
    @btn-edit="editItem(selectedValue)"
    @btn-refresh="refreshItem"
  />
  <slot :item="selectedItem"></slot>
  <!-- {{ selectedValue }} =={{ modelValue }}=={{ itemName }} -->
</template>
<script>
import { mapActions } from "vuex";
import { getMyGemService } from "@/services";
// import store from "../../../store";
export default {
  inject: ["service", "meta", "windowIndex"],
  props: {
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    emptyFilterMessage: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    // filter: {
    //   type: Boolean,
    //   required: true,
    // },
    // editable: {
    //   type: Boolean,
    //   required: true,
    // },
    icon: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    btnCreate: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
    serviceId: {
      type: Number,
    },
    idexing: {
      type: Number,
    },

    array: {
      type: [String, Array],
      default: "",
    },
    headers: {
      type: [String, Array],
      default: "",
    },
    selection: {
      type: [String, Number],
      default: "",
    },
    exclude: {
      type: Object,
      default: () => {
        return null;
      },
    },
    inputAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    updatedData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noMarginTop: Boolean,
  },
  data() {
    return {
      selectedValue: this.modelValue,
      items: [],
      servicebyDomian: null,
      loading: false,
      itemName: null,
    };
  },
  created() {
    this.servicebyDomian = getMyGemService(this.serviceId);
  },
  mounted() {
    this.emitter.on(this.servicebyDomian.hookName("post"), (event) => {
      if (event.meta["cb"]) {
        event.meta.cb(event);
      }
    });
    this.refreshItem();

    // this.customerService = getMyGemService(34);
  },
  methods: {
    ...mapActions("fetch", ["fetch", "refresh"]),
    async fetchData() {
      this.loading = true;
      await this.refresh({
        serviceId: this.serviceId,
        data: this.data,
        service: this.servicebyDomian,
      })
        .then((data) => {
          this.items = data[this.servicebyDomian.DOMAIN];
          this.items.unshift({
            display_name: "None",
          });

          // if (this.serviceId == 58) {
          //   this.servicebyDomian.filterAccounts(this.items, this.data);
          // }
          if (this.exclude) {
            this.items = this.items.filter(
              (item) => item[this.exclude["key"]] != this.exclude["value"],
            );
          }
          this.items.forEach((element, idx) => {
            if (element.id == this.selectedValue) {
              this.itemName = element.display_name;
            }
            if (element.status == 0) {
              let textInactive = element.display_name.concat(" (INACTIVE)");
              element.display_name = textInactive;
            }
          });

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    addNewItem() {
      let props = {
        item: {
          service: this.servicebyDomian,
          key: "create",
          label:
            "Add " +
            this.servicebyDomian.vowel +
            "\xa0" +
            this.servicebyDomian.singular,
          icon: this.servicebyDomian.icon,
          source: "active-dp",
          data: this.data,
          domain: this.meta.service.DOMAIN,
          item: this.data,
          parent: this.meta.windowIndex,
          index: this.idexing,
          header: this.headers,
          cb: (event) => {
            if (event.data.id) {
              if (event.meta.service.DOMAIN == this.serviceId) {
                let find = this.items.find(
                  (value) => value.id == event.data.id,
                );

                if (find != null) {
                  // find.display_name = event.data.display_name;
                  find = { ...find, ...event.data };
                } else {
                  this.items.push(event.data);
                  this.$refs.selection.inputValue = event.data.id;
                  this.selectedValue = event.data.id;
                }
              }
            }
          },
        },
      };
      this.emitter.emit("open-gem", props);
    },
    editItem(id) {
      this.emitter.emit("open-gem", {
        item: {
          key: "edit",
          label: this.$t("edit"),
          isVisible: true,
          service: this.servicebyDomian,
          parent: this.meta.windowIndex,
          domain: this.meta.service.DOMAIN,
          header: this.headers,
          item: { id: id },
          cb: (event) => {
            if (event.meta.service.DOMAIN == this.serviceId) {
              const find = this.items.find(
                (value) => value.id == event.data.id,
              );

              // find.display_name = event.data.display_name;
              // find = { ...find, ...event.data };
              Object.entries(event.data).forEach(([key, value]) => {
                find[key] = value;
              });

              // find.display_name = "DAnish";
              if (event.data.status == 0) {
                let textInactive = find.display_name.concat(" (INACTIVE)");
                find.display_name = textInactive;
              }

              this.$emit("changeById", find);
            }
          },
        },
      });
    },
    change(data) {
      this.$emit("update:modelValue", data.value);
      this.$emit("change", data);
    },
    refreshItem() {
      this.fetchData();
    },
    serviceIdChnage() {
      this.servicebyDomian = getMyGemService(this.serviceId);
      this.fetchData();
      this.$refs.selection.inputValue = null;
    },
  },
  computed: {
    selectedItem() {
      const find = this.items.find((value) => value.id == this.selectedValue);
      return find;
    },
  },
  watch: {
    modelValue: {
      handler(val) {
        this.selectedValue = val;
      },
      deep: true,
    },
    serviceId: {
      handler() {
        this.serviceIdChnage();
      },
    },
  },
};
</script>
